import {
    Avatar,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import LoadingAnimation from "../../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../../Layouts/ButtonsControlled";
import { FormHeading } from "../../../Layouts/Heading";
import {
    getAllInstaller,
    reset,
    WorkingDaysInstaller,
} from "../../../Redux/InstallerSlice/InstallerSlice";
import uploadImage from "../../../Assets/images/uploadImage.png";
import { Container } from "@mui/system";

const WorkingDays = ({ nextForm }) => {
    const { isLodaing, isSuccess, isError, errors } = useSelector(
        (state) => state.installer
    );

    const dispatch = useDispatch();

    // const CallNotificationMethod = async () => {
    //     if (isSuccess) toast.success("successfully registered");
    //     await dispatch(reset());
    // };

    const formik = useFormik({
        initialValues: {
            user_id: "",
            day_id: [],
        },

        onSubmit: async (values) => {
            await dispatch(WorkingDaysInstaller(values));
            // await CallNotificationMethod();
            await dispatch(reset());
        },
    });

    // All Installers
    const { installer } = useSelector((state) => state.installer);
    const installersVal = installer?.data || [];

    const GetallInstallersAction = async () => {
        await dispatch(getAllInstaller());
        await dispatch(reset());
    };

    useEffect(() => {
        GetallInstallersAction();
    }, [dispatch]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    toast.error(errors[key].msg);
                });
            }
            const resetMethod = async () => {
                await dispatch(reset());
            };
            resetMethod();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values.user_id) {
            toast.success("Working days have been added successfully");
            nextForm();
        }
    }, [isSuccess]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        <FormHeading> Select Working Days </FormHeading>

                        <Container mt={3}>
                            <Grid container columns={12} spacing={3}>
                                <Grid item mb={1} xs={12} md={6}>
                                    <FormControl fullWidth required={true}>
                                        <InputLabel id="demo-simple-select-label">
                                            Installer
                                        </InputLabel>
                                        <Select
                                            id="user_id"
                                            name="user_id"
                                            label="Installer"
                                            required
                                            value={formik.values.user_id}
                                            onChange={formik.handleChange}
                                        >
                                            {installersVal?.map((key) => {
                                                if (key.days.length === 0) {
                                                    return (
                                                        <MenuItem
                                                            key={key.id}
                                                            value={key.id}
                                                        >
                                                            {console.log(key)}
                                                            {key.name}
                                                        </MenuItem>
                                                    );
                                                }
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="1"
                                            control={<Checkbox />}
                                            name="day_id"
                                            label="Saturday"
                                            onChange={formik.handleChange}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="2"
                                            control={<Checkbox />}
                                            name="day_id"
                                            label="sunday"
                                            onChange={formik.handleChange}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="3"
                                            control={<Checkbox />}
                                            onChange={formik.handleChange}
                                            name="day_id"
                                            label="Monday"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="4"
                                            control={<Checkbox />}
                                            onChange={formik.handleChange}
                                            name="day_id"
                                            label="Tuesday"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="5"
                                            control={<Checkbox />}
                                            name="day_id"
                                            label="Wedensday"
                                            onChange={formik.handleChange}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="6"
                                            control={<Checkbox />}
                                            onChange={formik.handleChange}
                                            name="day_id"
                                            label="Thursday"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            value="7"
                                            control={<Checkbox />}
                                            onChange={formik.handleChange}
                                            name="day_id"
                                            label="Friday"
                                        />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                        </Container>
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Save"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default WorkingDays;
